/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MedicationSuspendAliases {
  ADMINISTRATION_ROUTE_TYPE_FIELD = 'administration-route-type-field',
  ADMINISTRATION_ROUTE_TYPE_TEXT = 'administration-route-type-text',
  AUTOCOMPLETE_INFUSION_SUSPEND_REASON = 'autocomplete-infusion-suspend-reason',
  DT_CURRENT_TIME = 'dt-current-time',
  DT_CURRENT_TIME_INPUT = 'dt-current-time-input',
  FETCH_MEDICATION_SUSPEND_REASON = 'fetch-medication-suspend-reason',
  FIELD_REASON = 'field-reason',
  FIELD_TEXT_AREA_JUSTIFICATION = 'field-text-area-justification',
  FORM_MEDICATION_SUSPEND = 'form-medication-suspend',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_SUSPEND_CONTENT = 'layout-suspend-content',
  LAYOUT_SUSPEND_MEDICATION = 'layout-suspend-medication',
  MAPPER_INFUSION_SUSPEND_REASON = 'mapper-infusion-suspend-reason',
  MEDICATION_HEADER_FRAGMENT = 'medication-header-fragment',
  MEDICATION_SUSPEND_CONTEXTUAL_BAR = 'medication-suspend-contextual-bar',
  PANEL_MEDICATION_SUSPEND_CONTENT = 'panel-medication-suspend-content',
  PANEL_SUSPEND_MEDICATION = 'panel-suspend-medication',
  TEXT_AREA_JUSTIFICATION = 'text-area-justification',
  TEXT_INFUSION_SUSPEND_REASON = 'text-infusion-suspend-reason',
}
export { MedicationSuspendAliases };
